import {IRange} from "@pg-design/inputs-module";

import {FormRoomType} from "../types/RoomType";

export const getRoomTypes = (roomCount: IRange<number | "">, roomTypes: FormRoomType[]) => {
    const filteredRoomTypes = roomTypes.filter((roomType) => ![FormRoomType.BATHROOM, FormRoomType.LIVING_ROOM, FormRoomType.BEDROOM].includes(roomType)) || [];
    if (!roomCount.lower && !roomCount.upper) {
        return [...filteredRoomTypes, FormRoomType.BATHROOM];
    }

    if (roomCount.lower === 5) {
        return [...filteredRoomTypes, FormRoomType.BATHROOM, FormRoomType.LIVING_ROOM, ...new Array(4)].fill(
            FormRoomType.BEDROOM,
            2 + filteredRoomTypes.length,
            7 + filteredRoomTypes.length
        );
    }

    if (typeof roomCount.upper === "string") {
        return [...filteredRoomTypes, FormRoomType.BATHROOM];
    }

    return [...filteredRoomTypes, FormRoomType.BATHROOM, FormRoomType.LIVING_ROOM, ...new Array(roomCount.upper - 1)].fill(
        FormRoomType.BEDROOM,
        2 + filteredRoomTypes.length,
        roomCount.upper + 2 + filteredRoomTypes.length
    );
};
import {IRange} from "@pg-design/inputs-module";

import {FormRoomType} from "../types/RoomType";

export const getRoomTypes = (roomCount: IRange<number | "">, roomTypes: FormRoomType[]) => {
    const filteredRoomTypes = roomTypes.filter((roomType) => ![FormRoomType.BATHROOM, FormRoomType.LIVING_ROOM, FormRoomType.BEDROOM].includes(roomType)) || [];
    if (!roomCount.lower && !roomCount.upper) {
        return [...filteredRoomTypes, FormRoomType.BATHROOM];
    }

    if (roomCount.lower === 5) {
        return [...filteredRoomTypes, FormRoomType.BATHROOM, FormRoomType.LIVING_ROOM, ...new Array(4)].fill(
            FormRoomType.BEDROOM,
            2 + filteredRoomTypes.length,
            7 + filteredRoomTypes.length
        );
    }

    if (typeof roomCount.upper === "string") {
        return [...filteredRoomTypes, FormRoomType.BATHROOM];
    }

    return [...filteredRoomTypes, FormRoomType.BATHROOM, FormRoomType.LIVING_ROOM, ...new Array(roomCount.upper - 1)].fill(
        FormRoomType.BEDROOM,
        2 + filteredRoomTypes.length,
        roomCount.upper + 2 + filteredRoomTypes.length
    );
};
